import { useCallback, useMemo } from "react";
import classes from "./bulkSpareDetailPage.module.css";
import { useParams } from "react-router-dom";

import {
  useGetBulkSpareByIdQuery,
  useUpdateBulkSpareByIdMutation,
} from "../../../services/bulk/spares/bulkSparesApiSlice";

import { BulkSpareDetailForm } from "../../../component/bulk/bulkSpares/bulkSparesDetail/BulkSpareDetailForm";
import { BulkSpareGalleryPage } from "./bulkSpareGallery/BulkSpareGalleryPage";
import { BulkSpareDetailHead } from "../../../component/bulk/bulkSpares/bulkSparesDetail/BulkSpareDetailHead";
import { toast } from "react-toastify";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

export const BulkSpareDetailPage = () => {
  const { request_id } = useParams();

  const { data: bulkSpareData, isSuccess: isBulkSpareDataSuccess } =
    useGetBulkSpareByIdQuery(request_id);
  const [updateBulkSpare] = useUpdateBulkSpareByIdMutation();

  const initialValues = useMemo(() => {
    if (!bulkSpareData) return null;
    return { ...bulkSpareData.data };
  }, [bulkSpareData]);

  const handleSubmit = useCallback(
    async (formData) => {
      const payload = {
        lot_name: formData.lot_name,
        unit_type: formData.unit_type,
        state: formData.state,
        city: formData.city,
        sale_type: formData.sale_type,
        comments: formData.comments,
        features: formData.features,
        inspection_available: formData.inspection_available,
      };

      // Show a pending toast
      const toastId = toast.loading("Updating bulk spare...");

      try {
        await updateBulkSpare({
          request_id,
          data: payload,
        }).unwrap();

        toast.update(toastId, {
          render: "Bulk spare updated successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } catch (error) {
        const errorMessage =
          error?.data?.message ||
          error?.data?.error ||
          "Something went wrong. Please try again.";

        toast.update(toastId, {
          render: errorMessage,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      }
    },
    [request_id, updateBulkSpare],
  );
  if (!initialValues) return null;

  return isBulkSpareDataSuccess ? (
    <div className={classes.wrapper}>
      <BulkSpareDetailHead
        lot_name={initialValues?.lot_name}
        uploaded_on={initialValues?.uploaded_on}
        approval_status={initialValues?.approval_status}
      />
      <div className={classes.box}>
        <div className={classes.box__section}>
          <BulkSpareDetailForm
            initialValues={initialValues}
            onSubmit={handleSubmit}
          />
        </div>
        <div className={classes.box__section}>
          <BulkSpareGalleryPage />
        </div>
      </div>
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
